/* Unterdrückt ausgewählte Klaviyo-Popups (snippets/newsletter-klaviyo-blocker.liquid). data-kunde am Script-Tag: eingeloggt ja/nein. */
(function () {
  var CFG = (document.currentScript && document.currentScript.dataset) || {};
  var FORM_IDS = ['Sh9Srp', 'WLed6i']; // leer [] = alle Klaviyo-Popups blockieren
  var SUPPRESS_KEY = 'modolino_kl_suppress_until';
  var SUPPRESS_MS = 2 * 60 * 1000; // 2 Minuten
  var STYLE_ID = 'mdl-kl-blocker-css';

  /* Klicks auf diese Elemente starten die 2-Minuten-Sperre */
  var FREISCHALTEN_SELEKTOR = '.pdf-cta-button, .pdf-mini-button, .pdf-login-modal-btn--primary, [data-kl-suppress]';

  /* Login-Check: Liquid + JS-Fallbacks für neue Shopify-Kundenkonten */
  function istEingeloggt() {
    if (CFG.kunde === 'true') return true;
    try {
      var cid = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId);
      if (cid) return true;
    } catch (e) {}
    try {
      if (window.__st && window.__st.cid) return true;
    } catch (e) {}
    return false;
  }

  function sperreBis() {
    try {
      return Number(localStorage.getItem(SUPPRESS_KEY) || 0);
    } catch (e) {
      return 0;
    }
  }

  function istUnterdrueckt() {
    if (istEingeloggt()) return true;
    return Date.now() < sperreBis();
  }

  /* Selektoren für die zu blockierenden Formulare */
  function baueSelektoren() {
    if (!FORM_IDS.length) return 'div[class*="kl-private"]';
    return FORM_IDS.map(function (id) {
      return '[data-testid="klaviyo-form-' + id + '"], .klaviyo-form-' + id;
    }).join(', ');
  }

  /* Zusätzlich das umgebende Popup-Fenster (inkl. Hintergrund) erfassen.
     Eigene CSS-Regel, damit ältere Browser ohne :has() die erste Regel trotzdem anwenden. */
  function baueDialogSelektoren() {
    if (!FORM_IDS.length) return '';
    return FORM_IDS.map(function (id) {
      var innen = '[data-testid="klaviyo-form-' + id + '"], .klaviyo-form-' + id;
      return '[role="dialog"]:has(' + innen + '), [aria-modal="true"]:has(' + innen + ')';
    }).join(', ');
  }

  var SELEKTOR = baueSelektoren();
  var VERSTECKT = '{display:none !important; visibility:hidden !important;}';

  function cssAn() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    var css = SELEKTOR + VERSTECKT;
    var dialog = baueDialogSelektoren();
    if (dialog) css += '\n' + dialog + VERSTECKT;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function cssAus() {
    var s = document.getElementById(STYLE_ID);
    if (s && s.parentNode) s.parentNode.removeChild(s);
  }

  /* Gefundene Formulare samt Popup-Fenster direkt ausblenden */
  function verstecke(el) {
    var box = (el.closest && el.closest('[role="dialog"], [aria-modal="true"]')) || el;
    box.style.setProperty('display', 'none', 'important');
  }

  function versteckeIn(wurzel) {
    if (!wurzel || wurzel.nodeType !== 1 && wurzel !== document) return;
    try {
      if (wurzel !== document && wurzel.matches && wurzel.matches(SELEKTOR)) verstecke(wurzel);
      if (wurzel.querySelectorAll) {
        wurzel.querySelectorAll(SELEKTOR).forEach(verstecke);
      }
    } catch (e) {}
  }

  var observer = null;

  function starteObserver() {
    if (observer || !window.MutationObserver) return;
    observer = new MutationObserver(function (mutationen) {
      mutationen.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) versteckeIn(n);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function stoppeObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  var aktiv = false;
  var endeTimer = null;

  function planeEnde() {
    if (endeTimer) clearTimeout(endeTimer);
    if (istEingeloggt()) return;
    var rest = sperreBis() - Date.now();
    if (rest > 0) endeTimer = setTimeout(aktualisieren, rest + 50);
  }

  function aktualisieren() {
    var soll = istUnterdrueckt();
    if (soll && !aktiv) {
      aktiv = true;
      cssAn();
      versteckeIn(document);
      starteObserver();
      planeEnde();
    } else if (!soll && aktiv) {
      aktiv = false;
      cssAus();
      stoppeObserver();
    }
  }

  /* Klick auf einen Freischalten-Button: Popups für 2 Minuten sperren */
  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target.closest(FREISCHALTEN_SELEKTOR) : null;
    if (!ziel) return;
    try {
      localStorage.setItem(SUPPRESS_KEY, String(Date.now() + SUPPRESS_MS));
    } catch (err) {}
    aktualisieren();
    planeEnde();
  }, true);

  /* Start */
  aktualisieren();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aktualisieren);
  }
})();
